<template>
  <div>
    <div class="superuser-productsearch__top">
      <validation-observer
        ref="superuserProductSearchForm"
        tag="form"
        class="superuser-productsearch__form"
        @submit.prevent
        @keyup.enter="searchProduct()">
        <validation-provider v-slot="{errors}" rules="required" slim>
          <oie-base-input
            id="productRef"
            v-model="productRef"
            :label-text="`${tStatic('superUserSearchProductReferenceLabel')}*`"
            :placeholder="tStatic('superUserSearchProductReferencePlaceholder')"
            :error-messages="errors"
            class="superuser-productsearch__input"></oie-base-input>
        </validation-provider>
        <oie-base-button
          v-element-loader="{ endpoint: 'superuser/product/search' }"
          css-classes="button--with-border button--blue superuser-importsearch__action"
          text="Sök"
          @click="searchProduct()"></oie-base-button>
      </validation-observer>
    </div>
    <oie-superuser-search-product-result :rows="productRows"></oie-superuser-search-product-result>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data: () => ({
    productRef: null,
    productRows: null
    // existingCustomers: null,
    // erpCustomer: null,
    // erpCustomerImported: null,
    // skipClearState: false
  }),
  computed: {
  },

  mounted() {
  },
  methods: {
    async searchProduct() {
      this.clearSearch()

      const isValid = await this.$refs.superuserProductSearchForm.validate()

      if (!isValid) {
        return
      }

      httpService.post('superuser/product/search', { productRef: this.productRef })
        .then(({ data }) => {
          this.productRows = data
        }).catch((error) => {
          if (error.response.status === 409) {
            this.$refs.superuserProductSearchForm.setErrors(error.response.data.errors)
          }
        })
    },
    clearSearch() {
      // this.existingCustomers = null
      // this.erpCustomer = null
      if (!this.skipClearState) {
        // this.erpCustomerImported = null
      } else {
        this.skipClearState = false
      }
    }
  }
}
</script>

<style lang="scss">
.superuser-productsearch__top {
  display: flex;
  flex-direction: column;
  margin-bottom: measure(full);

  @include media(medium) {
    flex-direction: row;
  }
}

.superuser-productsearch__form {
  display: flex;
  flex-direction: column;
  width: 100%;
  order: 1;

  @include media(small) {
    flex-direction: row;
    max-width: 30rem;
  }

  @include media(medium) {
    order: initial;
  }
}

.superuser-productsearch__input {
  margin-bottom: measure(quarter);

  @include media(small) {
    margin-bottom: 0;
    margin-right: measure(half);
  }
}

.superuser-productsearch__action {
  width: 100%;

  @include media(small) {
    width: auto;
    min-width: 9rem;
    margin-top: 1.6875rem;
  }
}

.superuser-product-form__block-content {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: measure(half);
  margin-bottom: measure(half);
}

.superuser-product__input-wide {
  max-width: 31rem;
}

.superuser-product__action {
  width: 100%;
  margin-bottom: measure(full);

  @include media(small) {
    width: auto;
    min-width: 9rem;
    margin-top: 1.6875rem;
  }
}

.superuser-product-from__block-actions {
  display: flex;
  align-items: center;
}

.superuser-product-from__success {
  color: color(text-green);
}
</style>
